import {createAsyncThunk} from "@reduxjs/toolkit";
import CriteoTracker from "../../services/CriteoClient";

export const triggerEventAsync = createAsyncThunk(
    'marketing/triggerEvent',
    async (arg, {dispatch, getState, rejectWithValue}) => {
        try {

            const account = getState().account.account;
            const lastFundsAddedToCustomerAccountEvent = getState().ecommerce.lastFundsAddedToCustomerAccountEvent;

            switch(arg.eventName){
                case 'registration':
                    //CriteoTracker.triggerRegistered(account);
                    break;
                case 'login':
                    //CriteoTracker.triggerLogin(account);
                    break;
                case "addFundsStart":
                    //CriteoTracker.triggerDepositOpened(account, arg.products);
                    break;
                case 'deposit':
                    if( lastFundsAddedToCustomerAccountEvent.IsFirstDeposit)
                        window.twq?.('event', 'tw-q8p5z-qaq7o', {});
                    //CriteoTracker.triggerDepositCompleted(account, lastFundsAddedToCustomerAccountEvent);
                    break;
                default:
                    console.warn(`Unhandled marketing event: ${arg.eventName}`);
            }

            return 'ok';
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);